/**
 * Created by jonas on 2022-10-14.
 */
import {SimpleReelModelSymbolData} from "../../core/reel/simplereel/SimpleReelModel";
import {TheCage} from "../TheCage";
import {TheCageSound} from "../sound/TheCageSound";
import {SymbolStopCallBackData} from "../../core/reel/simplereel/SimpleMatrixAvalancheModel";
import {TheCageSymbol, TheCageSymbolStates} from "../reels/TheCageSymbol";
import {ScatterSymbol} from "../reels/ScatterSymbol";
import {gsap} from "gsap";
import {TheCageGameMode} from "../server/TheCageGameMode";

export class ReelUtils {

    constructor() {
    }

    public static scatters:SimpleReelModelSymbolData[] = [];

    public static playLandingSound(symbolData:SimpleReelModelSymbolData, data:SymbolStopCallBackData, isSingleSymbolDrop:boolean):void {

        if (data.isNearWin) {
            TheCage.soundPlayer.playSound(TheCageSound.SYM_COLLAPSE.next());
            TheCage.soundPlayer.playSound(TheCageSound.SYM_LAND_NEAR_WIN.next());
        } else {
            if (isSingleSymbolDrop){
                TheCage.soundPlayer.playSound(TheCageSound.SYM_COLLAPSE.next());
            }
        }

        // the magic numbers are the positions of the bottom leftmost symbol of each "diagonal" reel
        const playReelLanding = TheCage.model.data.mode == TheCageGameMode.FREESPIN || TheCage.model.data.mode == TheCageGameMode.FREESPIN_AVALANCHE
                                ? (symbolData.reelId == 0) ||
                                  (symbolData.reelId == 2 && symbolData.reelPosition == 2) ||
                                  (symbolData.reelId == 4 && symbolData.reelPosition == 1) ||
                                  (symbolData.reelId == 6 && symbolData.reelPosition == 2) ||
                                  (symbolData.reelId == 8 && symbolData.reelPosition == 2)
                                : (symbolData.reelId == 0) ||
                                  (symbolData.reelId == 1 && symbolData.reelPosition == 3) ||
                                  (symbolData.reelId == 3 && symbolData.reelPosition == 3) ||
                                  (symbolData.reelId == 5 && symbolData.reelPosition == 3);

        if (playReelLanding && !isSingleSymbolDrop){
            TheCage.soundPlayer.playSound(TheCageSound.REELS_LANDING.next());
        }


    }

    public static symbolStopDropIn(symbolData:SimpleReelModelSymbolData, data:SymbolStopCallBackData):gsap.core.Timeline {
        return ReelUtils.symbolStop(symbolData,data,data.isSingleSymbolDrop);
    }

    public static symbolStopFillUp(symbolData:SimpleReelModelSymbolData, data:SymbolStopCallBackData):gsap.core.Timeline {
        return ReelUtils.symbolStop(symbolData,data,data.isSingleSymbolDrop);
    }

    public static symbolStop(symbolData:SimpleReelModelSymbolData, data:SymbolStopCallBackData, isSingleSymbolDrop:boolean):gsap.core.Timeline {
        const stopTl = gsap.timeline();

        let bounceLanding = data.isNearWin;

        stopTl.add(()=>{ ReelUtils.playLandingSound(symbolData,data, isSingleSymbolDrop)});


        const symbol = <TheCageSymbol>symbolData.positionable;

        if (symbolData.name == "S1" || symbolData.name == "S2") {
            bounceLanding = true;

            stopTl.add(() => {
                symbol.getStateAnimation(TheCageSymbolStates.LANDING);
                ReelUtils.getScatterAttention(symbolData);
            });

        }
        else if (symbolData.name == "WB"){
            stopTl.add(()=>{TheCage.soundPlayer.playSound(TheCageSound.X_BOMB_LANDING.next())});
            stopTl.add(symbol.getStateAnimation(TheCageSymbolStates.LANDING));
            bounceLanding = true;
        }
        else if (symbolData.name == "BN"){
            stopTl.add(()=>{TheCage.soundPlayer.playSound(TheCageSound.FS_GLOVE_LAND)});
            stopTl.add(symbol.getStateAnimation(TheCageSymbolStates.LANDING));
            bounceLanding = true;
        }


        if (bounceLanding){
            stopTl.add(() => {TheCage.reelView.getBounceShake()},0);
        }


        return stopTl;

    }

    public static getScatterAttention(symbolData:SimpleReelModelSymbolData){
        const tl = gsap.timeline();


        let stopSound = TheCageSound.SCATTER_LANDING_S1[ReelUtils.scatters.length];
        tl.add(()=>{TheCage.soundPlayer.playSound(stopSound)});
        ReelUtils.scatters.push(symbolData);
        if (ReelUtils.scatters.length == 1){
            // stopTl.add((<ScatterSymbol>symbol).getIdleAnimation(), landEndTime);
        }
        else if (ReelUtils.scatters.length == 2){

            for (let scatterData of ReelUtils.scatters){
                const scatterSymbol = <ScatterSymbol>scatterData.positionable;
                tl.add(scatterSymbol.getStateAnimation(TheCageSymbolStates.ATTENTION), 0.4);
            }
        }
        else if (ReelUtils.scatters.length == 3){
            for (let scatterData of ReelUtils.scatters){
                const scatterSymbol = <ScatterSymbol>scatterData.positionable;
                tl.add(scatterSymbol.getStateAnimation(TheCageSymbolStates.WIN_TINY), 0.4);
            }
            TheCage.model.hasWonFsClient = true;
        }

        return tl;
    }


    public static nearWinToggle(start:boolean, openRows:boolean[] = [true, true, true, true, true, true]) {
        if (start){
            TheCage.reelView.startAnticipation();
        } else {
            TheCage.reelView.stopAnticipation();
        }
    }

    public static resetScatter() {
        ReelUtils.scatters = [];
    }

    public static updateScatters() {
        const tl = gsap.timeline();
        const symbolDatas = TheCage.reelView.avalancheMatrixModel.getAllSymbolsWithNames(["S1", "S2"]);
        let i = 0;
        for (let symbolData of symbolDatas) {
            const symbol = <ScatterSymbol>symbolData.positionable;
            tl.add(symbol.getIdleAnimation(i * 0.6), 0);
            i++;
        }
    }

}